/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/thread_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  RpcStatus,
  ThreadServiceActivatePlanBody,
  ThreadServiceCommitArtifactsBody,
  ThreadServiceCreateThreadBody,
  ThreadServiceDeactivatePlanBody,
  ThreadServiceDehydrateThreadBody,
  ThreadServiceDeleteEventBody,
  ThreadServiceDeployBody,
  ThreadServiceDiffArtifactsBody,
  ThreadServiceDiscardArtifactsBody,
  ThreadServiceEmbedAudioBatchBody,
  ThreadServiceEmbedAudioBody,
  ThreadServiceEmbedImageBatchBody,
  ThreadServiceEmbedImageBody,
  ThreadServiceEmbedTextBatchBody,
  ThreadServiceEmbedTextBody,
  ThreadServiceEmbedVideoBatchBody,
  ThreadServiceEmbedVideoBody,
  ThreadServiceForkThreadBody,
  ThreadServiceGrepArtifactsBody,
  ThreadServiceInvokeToolBody,
  ThreadServiceMarkStepBody,
  ThreadServiceRehydrateThreadBody,
  ThreadServiceResetConfigBody,
  ThreadServiceResetEventsBody,
  ThreadServiceResetPlanBody,
  ThreadServiceRestoreEventBody,
  ThreadServiceSendMessageBody,
  ThreadServiceSendMessageSyncBody,
  ThreadServiceSendToolCallBody,
  ThreadServiceSendToolResultBody,
  ThreadServiceSetFeedbackBody,
  ThreadServiceStartCompactionBody,
  ThreadServiceStopBody,
  ThreadServiceTransferBody,
  ThreadServiceUpdateArtifactBody,
  ThreadServiceUpdateThreadBody,
  ThreadServiceUpdateThreadMemoryBody,
  ThreadServiceUpgradeAllThreadsBody,
  ThreadServiceUpgradeThreadBody,
  ThreadServiceWakeBody,
  V1Artifact,
  V1ArtifactContentResponse,
  V1CommitArtifactsResponse,
  V1DeleteEventResponse,
  V1DeployResponse,
  V1DiffArtifactsResponse,
  V1DiscardArtifactsResponse,
  V1EmbedBatchResponse,
  V1EmbedResponse,
  V1EmbedderInfo,
  V1FilterSchemaResponse,
  V1GetArtifactDiffResponse,
  V1GetArtifactsStagingSummaryResponse,
  V1GetEventsResponse,
  V1GetQueueResponse,
  V1GetThreadContextResponse,
  V1GetThreadMemoryResponse,
  V1GrepArtifactsResponse,
  V1InvokeToolResponse,
  V1ListAllThreadsResponse,
  V1ListArtifactsResponse,
  V1ListThreadsResponse,
  V1ListToolsRequest,
  V1ListToolsResponse,
  V1MemoryBlock,
  V1ModelInfo,
  V1Plan,
  V1ResetConfigResponse,
  V1ResetEventsResponse,
  V1RestoreEventResponse,
  V1SendMessageResponse,
  V1SendToolCallResponse,
  V1SendToolResultResponse,
  V1SetFeedbackResponse,
  V1StartCompactionResponse,
  V1StopResponse,
  V1SubscribeAgentThreadStatusRequest,
  V1SubscribeThreadRequest,
  V1SubscribeThreadStatusRequest,
  V1Thread,
  V1ThreadCostSummary,
  V1ThreadCustomizationsResponse,
  V1Tool,
  V1UpgradeAllThreadsResponse,
  V1UpgradeThreadResponse,
  V1WakeResponse,
  WorkspaceClearThreadMemory200,
  WorkspaceClearThreadMemoryParams,
  WorkspaceDeleteAllThreads200,
  WorkspaceDeleteAllThreadsParams,
  WorkspaceDeleteArtifact200,
  WorkspaceDeleteArtifactParams,
  WorkspaceDeleteThread200,
  WorkspaceDeleteThreadParams,
  WorkspaceGetActivePlanParams,
  WorkspaceGetArtifactContentParams,
  WorkspaceGetArtifactDiffParams,
  WorkspaceGetArtifactParams,
  WorkspaceGetArtifactsStagingSummaryParams,
  WorkspaceGetEmbedderInfoParams,
  WorkspaceGetEventsParams,
  WorkspaceGetFilterSchemaParams,
  WorkspaceGetModelInfoParams,
  WorkspaceGetQueueParams,
  WorkspaceGetThreadContextParams,
  WorkspaceGetThreadCostSummaryParams,
  WorkspaceGetThreadCustomizationsParams,
  WorkspaceGetThreadMemoryBlockParams,
  WorkspaceGetThreadMemoryParams,
  WorkspaceGetThreadParams,
  WorkspaceGetToolParams,
  WorkspaceGetUtilityGeneratorModelInfoParams,
  WorkspaceListAllThreadsParams,
  WorkspaceListArtifactsParams,
  WorkspaceListThreadsParams,
  WorkspaceSendMessageSync200,
  WorkspaceSubscribeAgentThreadStatus200,
  WorkspaceSubscribeThread200,
  WorkspaceSubscribeThreadStatus200,
  WorkspaceTransfer200,
} from '../../models';

/**
 * @summary Lists all threads for an agent.
 */
export const workspaceListThreads = (
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceListThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListThreadsQueryKey(organization, workspace, agentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListThreads>>
  > = ({ signal }) =>
    workspaceListThreads(organization, workspace, agentId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListThreads>>
>;
export type WorkspaceListThreadsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListThreads<
  TData = Awaited<ReturnType<typeof workspaceListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: undefined | WorkspaceListThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListThreads>>,
          TError,
          Awaited<ReturnType<typeof workspaceListThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListThreads<
  TData = Awaited<ReturnType<typeof workspaceListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListThreads>>,
          TError,
          Awaited<ReturnType<typeof workspaceListThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListThreads<
  TData = Awaited<ReturnType<typeof workspaceListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all threads for an agent.
 */

export function useWorkspaceListThreads<
  TData = Awaited<ReturnType<typeof workspaceListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListThreadsQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes all threads for an agent.
 */
export const workspaceDeleteAllThreads = (
  organization: string,
  workspace: string,
  agentId: string,
  params?: WorkspaceDeleteAllThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteAllThreads200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteAllThreadsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteAllThreads>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      params?: WorkspaceDeleteAllThreadsParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    params?: WorkspaceDeleteAllThreadsParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteAllThreads'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteAllThreads>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      params?: WorkspaceDeleteAllThreadsParams;
    }
  > = props => {
    const { organization, workspace, agentId, params } = props ?? {};

    return workspaceDeleteAllThreads(
      organization,
      workspace,
      agentId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteAllThreadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteAllThreads>>
>;

export type WorkspaceDeleteAllThreadsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes all threads for an agent.
 */
export const useWorkspaceDeleteAllThreads = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteAllThreads>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        params?: WorkspaceDeleteAllThreadsParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    params?: WorkspaceDeleteAllThreadsParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteAllThreadsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The thread_id is auto-generated. Optionally provide a title and description.
 * @summary Creates a new thread.
 */
export const workspaceCreateThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadServiceCreateThreadBody: ThreadServiceCreateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads`,
    threadServiceCreateThreadBody,
    options,
  );
};

export const getWorkspaceCreateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceCreateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ThreadServiceCreateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceCreateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ThreadServiceCreateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceCreateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceCreateThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ThreadServiceCreateThreadBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceCreateThread(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceCreateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceCreateThread>>
>;
export type WorkspaceCreateThreadMutationBody = ThreadServiceCreateThreadBody;
export type WorkspaceCreateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new thread.
 */
export const useWorkspaceCreateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceCreateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ThreadServiceCreateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceCreateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ThreadServiceCreateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceCreateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns thread metadata and event count without loading the full event history.
Returns NOT_FOUND if the thread doesn't exist.
 * @summary Gets a thread by ID.
 */
export const workspaceGetThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetThreadParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThread>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThread>>
  > = ({ signal }) =>
    workspaceGetThread(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThread>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThread>>
>;
export type WorkspaceGetThreadQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThread<
  TData = Awaited<ReturnType<typeof workspaceGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetThreadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThread>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThread>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThread<
  TData = Awaited<ReturnType<typeof workspaceGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThread>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThread>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThread<
  TData = Awaited<ReturnType<typeof workspaceGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThread>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a thread by ID.
 */

export function useWorkspaceGetThread<
  TData = Awaited<ReturnType<typeof workspaceGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThread>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a thread and all its events.
 */
export const workspaceDeleteThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDeleteThreadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteThread200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      params?: WorkspaceDeleteThreadParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    params?: WorkspaceDeleteThreadParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      params?: WorkspaceDeleteThreadParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, params } = props ?? {};

    return workspaceDeleteThread(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteThread>>
>;

export type WorkspaceDeleteThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a thread and all its events.
 */
export const useWorkspaceDeleteThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        params?: WorkspaceDeleteThreadParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    params?: WorkspaceDeleteThreadParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a thread's title and/or description.
 */
export const workspaceUpdateThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceUpdateThreadBody: ThreadServiceUpdateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}`,
    threadServiceUpdateThreadBody,
    options,
  );
};

export const getWorkspaceUpdateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpdateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpdateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpdateThreadBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceUpdateThread(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateThread>>
>;
export type WorkspaceUpdateThreadMutationBody = ThreadServiceUpdateThreadBody;
export type WorkspaceUpdateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a thread's title and/or description.
 */
export const useWorkspaceUpdateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceUpdateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpdateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This promotes the thread's per-thread config to become the new agent defaults.
The thread's customization remains in place.
 * @summary Deploys the thread's config customizations to the agent template.
 */
export const workspaceDeploy = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceDeployBody: ThreadServiceDeployBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeployResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/agent:deploy`,
    threadServiceDeployBody,
    options,
  );
};

export const getWorkspaceDeployMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeploy>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeployBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeploy>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeployBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeploy'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeploy>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeployBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceDeploy(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeployMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeploy>>
>;
export type WorkspaceDeployMutationBody = ThreadServiceDeployBody;
export type WorkspaceDeployMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deploys the thread's config customizations to the agent template.
 */
export const useWorkspaceDeploy = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeploy>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeployBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeploy>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeployBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeployMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * After reset, the thread will use the agent's default generator and config.
 * @summary ============================================================================
Reset & Deploy
============================================================================
Resets all per-thread config customizations to agent defaults.
 */
export const workspaceResetConfig = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceResetConfigBody: ThreadServiceResetConfigBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ResetConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/agent:reset`,
    threadServiceResetConfigBody,
    options,
  );
};

export const getWorkspaceResetConfigMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceResetConfig>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetConfigBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceResetConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetConfigBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceResetConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceResetConfig>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetConfigBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceResetConfig(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceResetConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceResetConfig>>
>;
export type WorkspaceResetConfigMutationBody = ThreadServiceResetConfigBody;
export type WorkspaceResetConfigMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Reset & Deploy
============================================================================
Resets all per-thread config customizations to agent defaults.
 */
export const useWorkspaceResetConfig = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceResetConfig>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetConfigBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceResetConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetConfigBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceResetConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Threads are version-pinned at creation time and only this explicit
call moves them. The thread's per-thread template-group overrides
survive verbatim; the new version becomes the base they layer
onto. Downgrades and same-version targets are rejected. If the
target template requires variables the thread doesn't carry, the
response's `missing_variables` is populated and no state is
mutated — the caller re-prompts and re-issues.
 * @summary Moves a thread's pin to a different agent version.
 */
export const workspaceUpgradeThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceUpgradeThreadBody: ThreadServiceUpgradeThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeThreadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/agent:upgrade`,
    threadServiceUpgradeThreadBody,
    options,
  );
};

export const getWorkspaceUpgradeThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpgradeThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpgradeThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpgradeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpgradeThreadBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpgradeThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpgradeThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpgradeThreadBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceUpgradeThread(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpgradeThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpgradeThread>>
>;
export type WorkspaceUpgradeThreadMutationBody = ThreadServiceUpgradeThreadBody;
export type WorkspaceUpgradeThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Moves a thread's pin to a different agent version.
 */
export const useWorkspaceUpgradeThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpgradeThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceUpgradeThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpgradeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpgradeThreadBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpgradeThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Artifact CRUD (Thread-Scoped)
============================================================================
Lists artifacts with optional filters.
Supports S3-style delimiter for folder navigation.
Thread ID is required for variable-scoped artifact access.
 */
export const workspaceListArtifacts = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListArtifactsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListArtifactsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceListArtifactsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListArtifactsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListArtifactsQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListArtifacts>>
  > = ({ signal }) =>
    workspaceListArtifacts(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListArtifacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListArtifactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListArtifacts>>
>;
export type WorkspaceListArtifactsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListArtifacts<
  TData = Awaited<ReturnType<typeof workspaceListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceListArtifactsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListArtifacts>>,
          TError,
          Awaited<ReturnType<typeof workspaceListArtifacts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListArtifacts<
  TData = Awaited<ReturnType<typeof workspaceListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListArtifacts>>,
          TError,
          Awaited<ReturnType<typeof workspaceListArtifacts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListArtifacts<
  TData = Awaited<ReturnType<typeof workspaceListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Artifact CRUD (Thread-Scoped)
============================================================================
Lists artifacts with optional filters.
Supports S3-style delimiter for folder navigation.
Thread ID is required for variable-scoped artifact access.
 */

export function useWorkspaceListArtifacts<
  TData = Awaited<ReturnType<typeof workspaceListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListArtifactsQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets artifact metadata by URI.
 */
export const workspaceGetArtifact = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Artifact>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetArtifactQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: WorkspaceGetArtifactParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetArtifactQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifact>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetArtifactQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetArtifact>>
  > = ({ signal }) =>
    workspaceGetArtifact(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetArtifact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetArtifactQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetArtifact>>
>;
export type WorkspaceGetArtifactQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetArtifact<
  TData = Awaited<ReturnType<typeof workspaceGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | WorkspaceGetArtifactParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifact>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifact>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifact>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifact<
  TData = Awaited<ReturnType<typeof workspaceGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifact>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifact>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifact>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifact<
  TData = Awaited<ReturnType<typeof workspaceGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifact>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets artifact metadata by URI.
 */

export function useWorkspaceGetArtifact<
  TData = Awaited<ReturnType<typeof workspaceGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifact>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetArtifactQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes an artifact by URI.
 */
export const workspaceDeleteArtifact = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceDeleteArtifactParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteArtifact200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteArtifactMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteArtifact>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      params?: WorkspaceDeleteArtifactParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    params?: WorkspaceDeleteArtifactParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteArtifact'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteArtifact>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      params?: WorkspaceDeleteArtifactParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, artifactUri, params } =
      props ?? {};

    return workspaceDeleteArtifact(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteArtifactMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteArtifact>>
>;

export type WorkspaceDeleteArtifactMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an artifact by URI.
 */
export const useWorkspaceDeleteArtifact = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteArtifact>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        artifactUri: string;
        params?: WorkspaceDeleteArtifactParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    params?: WorkspaceDeleteArtifactParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteArtifactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Creates or updates an artifact.
 */
export const workspaceUpdateArtifact = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  threadServiceUpdateArtifactBody: ThreadServiceUpdateArtifactBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Artifact>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    threadServiceUpdateArtifactBody,
    options,
  );
};

export const getWorkspaceUpdateArtifactMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateArtifact>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      data: ThreadServiceUpdateArtifactBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    data: ThreadServiceUpdateArtifactBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateArtifact'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateArtifact>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      data: ThreadServiceUpdateArtifactBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, artifactUri, data } =
      props ?? {};

    return workspaceUpdateArtifact(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateArtifactMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateArtifact>>
>;
export type WorkspaceUpdateArtifactMutationBody =
  ThreadServiceUpdateArtifactBody;
export type WorkspaceUpdateArtifactMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates or updates an artifact.
 */
export const useWorkspaceUpdateArtifact = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateArtifact>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        artifactUri: string;
        data: ThreadServiceUpdateArtifactBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    data: ThreadServiceUpdateArtifactBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateArtifactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets artifact content by URI.
 */
export const workspaceGetArtifactContent = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactContentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArtifactContentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:content`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetArtifactContentQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: WorkspaceGetArtifactContentParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:content`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetArtifactContentQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetArtifactContentQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetArtifactContent>>
  > = ({ signal }) =>
    workspaceGetArtifactContent(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetArtifactContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetArtifactContent>>
>;
export type WorkspaceGetArtifactContentQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetArtifactContent<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | WorkspaceGetArtifactContentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifactContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifactContent<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifactContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifactContent<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets artifact content by URI.
 */

export function useWorkspaceGetArtifactContent<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetArtifactContentQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the unified diff for a specific artifact if it has staged changes.
Returns empty diff for binary files or if no changes exist.
 * @summary Gets the diff for a single staged artifact.
 */
export const workspaceGetArtifactDiff = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactDiffParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetArtifactDiffResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetArtifactDiffQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: WorkspaceGetArtifactDiffParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetArtifactDiffQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetArtifactDiffQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetArtifactDiff>>
  > = ({ signal }) =>
    workspaceGetArtifactDiff(
      organization,
      workspace,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetArtifactDiffQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetArtifactDiff>>
>;
export type WorkspaceGetArtifactDiffQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetArtifactDiff<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | WorkspaceGetArtifactDiffParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifactDiff>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifactDiff<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifactDiff>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifactDiff<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the diff for a single staged artifact.
 */

export function useWorkspaceGetArtifactDiff<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: WorkspaceGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetArtifactDiffQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persists all staged changes (additions, modifications, deletions) to
the underlying store. For stores without staging, this is a no-op.
 * @summary Commits staged artifact changes to the underlying store.
 */
export const workspaceCommitArtifacts = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceCommitArtifactsBody: ThreadServiceCommitArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CommitArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts:commit`,
    threadServiceCommitArtifactsBody,
    options,
  );
};

export const getWorkspaceCommitArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceCommitArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceCommitArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceCommitArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceCommitArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceCommitArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceCommitArtifacts>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceCommitArtifactsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceCommitArtifacts(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceCommitArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceCommitArtifacts>>
>;
export type WorkspaceCommitArtifactsMutationBody =
  ThreadServiceCommitArtifactsBody;
export type WorkspaceCommitArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Commits staged artifact changes to the underlying store.
 */
export const useWorkspaceCommitArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceCommitArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceCommitArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceCommitArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceCommitArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceCommitArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns information about artifacts that have been modified but not yet
committed. For stores with staging enabled, this shows pending changes.
For stores without staging, returns an empty response.
 * @summary Gets staged artifact changes with optional diff content.
 */
export const workspaceDiffArtifacts = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceDiffArtifactsBody: ThreadServiceDiffArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts:diff`,
    threadServiceDiffArtifactsBody,
    options,
  );
};

export const getWorkspaceDiffArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDiffArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiffArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDiffArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiffArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDiffArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDiffArtifacts>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiffArtifactsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceDiffArtifacts(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDiffArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiffArtifacts>>
>;
export type WorkspaceDiffArtifactsMutationBody = ThreadServiceDiffArtifactsBody;
export type WorkspaceDiffArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Gets staged artifact changes with optional diff content.
 */
export const useWorkspaceDiffArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDiffArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDiffArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDiffArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiffArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDiffArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears all pending changes (additions, modifications, deletions) from
the staging area. For stores without staging, this is a no-op.
 * @summary Discards all staged artifact changes without committing.
 */
export const workspaceDiscardArtifacts = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceDiscardArtifactsBody: ThreadServiceDiscardArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiscardArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts:discard`,
    threadServiceDiscardArtifactsBody,
    options,
  );
};

export const getWorkspaceDiscardArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDiscardArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiscardArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDiscardArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiscardArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDiscardArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDiscardArtifacts>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiscardArtifactsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceDiscardArtifacts(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDiscardArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiscardArtifacts>>
>;
export type WorkspaceDiscardArtifactsMutationBody =
  ThreadServiceDiscardArtifactsBody;
export type WorkspaceDiscardArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Discards all staged artifact changes without committing.
 */
export const useWorkspaceDiscardArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDiscardArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDiscardArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDiscardArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiscardArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDiscardArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Search (Thread-Scoped)
============================================================================
Searches artifact contents using regex pattern matching.
 */
export const workspaceGrepArtifacts = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceGrepArtifactsBody: ThreadServiceGrepArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GrepArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts:grep`,
    threadServiceGrepArtifactsBody,
    options,
  );
};

export const getWorkspaceGrepArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGrepArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceGrepArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGrepArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceGrepArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceGrepArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGrepArtifacts>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceGrepArtifactsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceGrepArtifacts(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGrepArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGrepArtifacts>>
>;
export type WorkspaceGrepArtifactsMutationBody = ThreadServiceGrepArtifactsBody;
export type WorkspaceGrepArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Search (Thread-Scoped)
============================================================================
Searches artifact contents using regex pattern matching.
 */
export const useWorkspaceGrepArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGrepArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceGrepArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGrepArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceGrepArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceGrepArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns a lightweight summary of pending changes including counts and
change metadata without diff content. Use DiffArtifacts for full diffs.
 * @summary ============================================================================
Staging (Thread-Scoped)
============================================================================
Gets a summary of staged artifact changes.
 */
export const workspaceGetArtifactsStagingSummary = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetArtifactsStagingSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetArtifactsStagingSummaryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts:staging`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetArtifactsStagingSummaryQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetArtifactsStagingSummaryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifacts:staging`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetArtifactsStagingSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetArtifactsStagingSummaryQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>
  > = ({ signal }) =>
    workspaceGetArtifactsStagingSummary(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetArtifactsStagingSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>
>;
export type WorkspaceGetArtifactsStagingSummaryQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetArtifactsStagingSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Staging (Thread-Scoped)
============================================================================
Gets a summary of staged artifact changes.
 */

export function useWorkspaceGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetArtifactsStagingSummaryQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a unified view of all items contributing to the context window:
- Memory blocks (fixed and volatile)
- Enabled tools (fixed)
- Conversation history (compactable)

Each item includes its token count for context budget management.
 * @summary ============================================================================
Context Information (Thread-Scoped)
============================================================================
Gets thread context information including all context items with token counts.
 */
export const workspaceGetThreadContext = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadContextParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetThreadContextResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/context`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadContextQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetThreadContextParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/context`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadContextQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadContextQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThreadContext>>
  > = ({ signal }) =>
    workspaceGetThreadContext(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThreadContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThreadContext>>
>;
export type WorkspaceGetThreadContextQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThreadContext<
  TData = Awaited<ReturnType<typeof workspaceGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetThreadContextParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadContext>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadContext<
  TData = Awaited<ReturnType<typeof workspaceGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadContext>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadContext<
  TData = Awaited<ReturnType<typeof workspaceGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Context Information (Thread-Scoped)
============================================================================
Gets thread context information including all context items with token counts.
 */

export function useWorkspaceGetThreadContext<
  TData = Awaited<ReturnType<typeof workspaceGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadContextQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Prices the thread's usage aggregate (and its sub-agent delegations)
against the current effective-dated rate card. USD is computed at read
time, never stored.
 * @summary Gets a thread's cost summary.
 */
export const workspaceGetThreadCostSummary = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCostSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadCostSummary>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/cost`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadCostSummaryQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetThreadCostSummaryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadCostSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadCostSummaryQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>
  > = ({ signal }) =>
    workspaceGetThreadCostSummary(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadCostSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>
>;
export type WorkspaceGetThreadCostSummaryQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetThreadCostSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a thread's cost summary.
 */

export function useWorkspaceGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadCostSummaryQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deliberately uncached so the Deploy gate stays fresh.
Returns NOT_FOUND if the thread doesn't exist.
 * @summary Reports the thread's per-thread config customizations in one read:
whether Deploy has anything to promote, which sections are
customized, and whether generated card state is present.
 */
export const workspaceGetThreadCustomizations = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCustomizationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadCustomizationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/customizations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadCustomizationsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetThreadCustomizationsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/customizations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadCustomizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadCustomizationsQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>
  > = ({ signal }) =>
    workspaceGetThreadCustomizations(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadCustomizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>
>;
export type WorkspaceGetThreadCustomizationsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetThreadCustomizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Reports the thread's per-thread config customizations in one read:
whether Deploy has anything to promote, which sections are
customized, and whether generated card state is present.
 */

export function useWorkspaceGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadCustomizationsQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The thread context is required because the embedder may depend on
variables that are resolved per-thread. Returns dimension, max input
length, normalization, and provider information. Returns NOT_FOUND if
the agent has no embedder configured.
 * @summary Gets embedder information and capabilities for the agent's embedder.
 */
export const workspaceGetEmbedderInfo = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEmbedderInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedderInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetEmbedderInfoQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetEmbedderInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetEmbedderInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetEmbedderInfoQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>
  > = ({ signal }) =>
    workspaceGetEmbedderInfo(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetEmbedderInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>
>;
export type WorkspaceGetEmbedderInfoQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetEmbedderInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets embedder information and capabilities for the agent's embedder.
 */

export function useWorkspaceGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetEmbedderInfoQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generates an embedding for a single audio clip.
 */
export const workspaceEmbedAudio = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedAudioBody: ThreadServiceEmbedAudioBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-audio`,
    threadServiceEmbedAudioBody,
    options,
  );
};

export const getWorkspaceEmbedAudioMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedAudio>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedAudio>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedAudio'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedAudio>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedAudio(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedAudio>>
>;
export type WorkspaceEmbedAudioMutationBody = ThreadServiceEmbedAudioBody;
export type WorkspaceEmbedAudioMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single audio clip.
 */
export const useWorkspaceEmbedAudio = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedAudio>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedAudioBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedAudio>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedAudioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of audio clips.
 */
export const workspaceEmbedAudioBatch = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedAudioBatchBody: ThreadServiceEmbedAudioBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-audio-batch`,
    threadServiceEmbedAudioBatchBody,
    options,
  );
};

export const getWorkspaceEmbedAudioBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedAudioBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedAudioBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBatchBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedAudioBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedAudioBatch>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBatchBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedAudioBatch(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedAudioBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedAudioBatch>>
>;
export type WorkspaceEmbedAudioBatchMutationBody =
  ThreadServiceEmbedAudioBatchBody;
export type WorkspaceEmbedAudioBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of audio clips.
 */
export const useWorkspaceEmbedAudioBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedAudioBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedAudioBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedAudioBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBatchBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedAudioBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates an embedding for a single image (encoded bytes).
 */
export const workspaceEmbedImage = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedImageBody: ThreadServiceEmbedImageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-image`,
    threadServiceEmbedImageBody,
    options,
  );
};

export const getWorkspaceEmbedImageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedImage>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedImage>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedImage>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedImage(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedImage>>
>;
export type WorkspaceEmbedImageMutationBody = ThreadServiceEmbedImageBody;
export type WorkspaceEmbedImageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single image (encoded bytes).
 */
export const useWorkspaceEmbedImage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedImage>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedImageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedImage>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of images.
 */
export const workspaceEmbedImageBatch = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedImageBatchBody: ThreadServiceEmbedImageBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-image-batch`,
    threadServiceEmbedImageBatchBody,
    options,
  );
};

export const getWorkspaceEmbedImageBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedImageBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedImageBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBatchBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedImageBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedImageBatch>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBatchBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedImageBatch(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedImageBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedImageBatch>>
>;
export type WorkspaceEmbedImageBatchMutationBody =
  ThreadServiceEmbedImageBatchBody;
export type WorkspaceEmbedImageBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of images.
 */
export const useWorkspaceEmbedImageBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedImageBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedImageBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedImageBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBatchBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedImageBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if the agent has no embedder configured, or
FAILED_PRECONDITION if the configured embedder doesn't support text.
 * @summary Generates an embedding for a single text input.
 */
export const workspaceEmbedText = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedTextBody: ThreadServiceEmbedTextBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-text`,
    threadServiceEmbedTextBody,
    options,
  );
};

export const getWorkspaceEmbedTextMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedText>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedText>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedText'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedText>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedText(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedText>>
>;
export type WorkspaceEmbedTextMutationBody = ThreadServiceEmbedTextBody;
export type WorkspaceEmbedTextMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single text input.
 */
export const useWorkspaceEmbedText = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedText>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedTextBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedText>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedTextMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of text inputs.
 */
export const workspaceEmbedTextBatch = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedTextBatchBody: ThreadServiceEmbedTextBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-text-batch`,
    threadServiceEmbedTextBatchBody,
    options,
  );
};

export const getWorkspaceEmbedTextBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedTextBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedTextBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBatchBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedTextBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedTextBatch>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBatchBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedTextBatch(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedTextBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedTextBatch>>
>;
export type WorkspaceEmbedTextBatchMutationBody =
  ThreadServiceEmbedTextBatchBody;
export type WorkspaceEmbedTextBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of text inputs.
 */
export const useWorkspaceEmbedTextBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedTextBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedTextBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedTextBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBatchBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedTextBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates an embedding for a single video clip.
 */
export const workspaceEmbedVideo = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedVideoBody: ThreadServiceEmbedVideoBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-video`,
    threadServiceEmbedVideoBody,
    options,
  );
};

export const getWorkspaceEmbedVideoMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedVideo>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedVideo>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedVideo'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedVideo>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedVideo(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedVideo>>
>;
export type WorkspaceEmbedVideoMutationBody = ThreadServiceEmbedVideoBody;
export type WorkspaceEmbedVideoMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single video clip.
 */
export const useWorkspaceEmbedVideo = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedVideo>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedVideoBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedVideo>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of video clips.
 */
export const workspaceEmbedVideoBatch = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedVideoBatchBody: ThreadServiceEmbedVideoBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/embedder:embed-video-batch`,
    threadServiceEmbedVideoBatchBody,
    options,
  );
};

export const getWorkspaceEmbedVideoBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceEmbedVideoBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceEmbedVideoBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBatchBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceEmbedVideoBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceEmbedVideoBatch>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBatchBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceEmbedVideoBatch(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceEmbedVideoBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceEmbedVideoBatch>>
>;
export type WorkspaceEmbedVideoBatchMutationBody =
  ThreadServiceEmbedVideoBatchBody;
export type WorkspaceEmbedVideoBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of video clips.
 */
export const useWorkspaceEmbedVideoBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceEmbedVideoBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedVideoBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceEmbedVideoBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBatchBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceEmbedVideoBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This RPC returns the complete history of events for a thread, including
user inputs, assistant responses, tool calls, and their results.
Events are returned in chronological order.
 * @summary Retrieves all events from a thread.
 */
export const workspaceGetEvents = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetEventsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/events`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetEventsQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetEventsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetEventsQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetEvents>>
  > = ({ signal }) =>
    workspaceGetEvents(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetEvents>>
>;
export type WorkspaceGetEventsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetEvents<
  TData = Awaited<ReturnType<typeof workspaceGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetEvents>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetEvents<
  TData = Awaited<ReturnType<typeof workspaceGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetEvents>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetEvents<
  TData = Awaited<ReturnType<typeof workspaceGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all events from a thread.
 */

export function useWorkspaceGetEvents<
  TData = Awaited<ReturnType<typeof workspaceGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetEventsQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This RPC adds user input to the specified thread and returns a stream
of events representing the assistant's response. Events include output text,
tool calls, and completion metadata.
 * @summary ============================================================================
Events
============================================================================
Sends a message and streams back response events synchronously.
 */
export const workspaceSendMessageSync = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceSendMessageSyncBody: ThreadServiceSendMessageSyncBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceSendMessageSync200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/events`,
    threadServiceSendMessageSyncBody,
    options,
  );
};

export const getWorkspaceSendMessageSyncMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSendMessageSync>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageSyncBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSendMessageSync>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageSyncBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSendMessageSync'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSendMessageSync>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageSyncBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceSendMessageSync(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSendMessageSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSendMessageSync>>
>;
export type WorkspaceSendMessageSyncMutationBody =
  ThreadServiceSendMessageSyncBody;
export type WorkspaceSendMessageSyncMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Events
============================================================================
Sends a message and streams back response events synchronously.
 */
export const useWorkspaceSendMessageSync = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSendMessageSync>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendMessageSyncBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSendMessageSync>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageSyncBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSendMessageSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deletes an event and its entire associated turn from the thread.
 */
export const workspaceDeleteEvent = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceDeleteEventBody: ThreadServiceDeleteEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeleteEventResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/events:delete`,
    threadServiceDeleteEventBody,
    options,
  );
};

export const getWorkspaceDeleteEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeleteEventBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeleteEventBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteEvent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeleteEventBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceDeleteEvent(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteEvent>>
>;
export type WorkspaceDeleteEventMutationBody = ThreadServiceDeleteEventBody;
export type WorkspaceDeleteEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an event and its entire associated turn from the thread.
 */
export const useWorkspaceDeleteEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeleteEventBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeleteEventBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears the entire event history and associated feedback while preserving
all other thread state (plan, memory customizations, config customizations, scratchpad).
Returns FAILED_PRECONDITION if the thread is currently generating.
 * @summary Resets all events and feedback in a thread.
 */
export const workspaceResetEvents = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceResetEventsBody: ThreadServiceResetEventsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ResetEventsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/events:reset`,
    threadServiceResetEventsBody,
    options,
  );
};

export const getWorkspaceResetEventsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceResetEvents>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetEventsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceResetEvents>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetEventsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceResetEvents'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceResetEvents>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetEventsBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceResetEvents(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceResetEventsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceResetEvents>>
>;
export type WorkspaceResetEventsMutationBody = ThreadServiceResetEventsBody;
export type WorkspaceResetEventsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resets all events and feedback in a thread.
 */
export const useWorkspaceResetEvents = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceResetEvents>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetEventsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceResetEvents>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetEventsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceResetEventsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Restores a previously deleted event and its entire associated turn.
 */
export const workspaceRestoreEvent = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceRestoreEventBody: ThreadServiceRestoreEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RestoreEventResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/events:restore`,
    threadServiceRestoreEventBody,
    options,
  );
};

export const getWorkspaceRestoreEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceRestoreEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRestoreEventBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceRestoreEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRestoreEventBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceRestoreEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceRestoreEvent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRestoreEventBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceRestoreEvent(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceRestoreEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceRestoreEvent>>
>;
export type WorkspaceRestoreEventMutationBody = ThreadServiceRestoreEventBody;
export type WorkspaceRestoreEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Restores a previously deleted event and its entire associated turn.
 */
export const useWorkspaceRestoreEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceRestoreEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceRestoreEventBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceRestoreEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRestoreEventBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceRestoreEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Feedback is mutually exclusive - setting LIKE removes any DISLIKE and vice versa.
Setting the same feedback that already exists is a no-op.
Use FEEDBACK_TYPE_UNSPECIFIED to clear existing feedback.

Feedback is stored with the thread and is purely for analytics/UI purposes.
It is not visible to the LLM.
 * @summary ============================================================================
Feedback
============================================================================
Sets feedback (like/dislike) for a generation response.
 */
export const workspaceSetFeedback = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceSetFeedbackBody: ThreadServiceSetFeedbackBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SetFeedbackResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/feedback`,
    threadServiceSetFeedbackBody,
    options,
  );
};

export const getWorkspaceSetFeedbackMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSetFeedback>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSetFeedbackBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSetFeedback>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSetFeedbackBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSetFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSetFeedback>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSetFeedbackBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceSetFeedback(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSetFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSetFeedback>>
>;
export type WorkspaceSetFeedbackMutationBody = ThreadServiceSetFeedbackBody;
export type WorkspaceSetFeedbackMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Feedback
============================================================================
Sets feedback (like/dislike) for a generation response.
 */
export const useWorkspaceSetFeedback = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSetFeedback>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSetFeedbackBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSetFeedback>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSetFeedbackBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSetFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The thread context is required because the generator may depend on
variables that are resolved per-thread. Returns model capabilities
like supported features, token limits, and pricing information.
 * @summary ============================================================================
Model Info (Thread-Scoped)
============================================================================
Gets model information and capabilities for the agent's main generator.
 */
export const workspaceGetModelInfo = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetModelInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ModelInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator:model-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetModelInfoQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetModelInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator:model-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetModelInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetModelInfoQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetModelInfo>>
  > = ({ signal }) =>
    workspaceGetModelInfo(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetModelInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetModelInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetModelInfo>>
>;
export type WorkspaceGetModelInfoQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetModelInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetModelInfo>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetModelInfo>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Model Info (Thread-Scoped)
============================================================================
Gets model information and capabilities for the agent's main generator.
 */

export function useWorkspaceGetModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetModelInfoQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The message is added to the thread and generation begins asynchronously.
Response events arrive via SubscribeThread stream or SSE, not this RPC.
 * @summary Sends a message to a thread (fire and forget).
 */
export const workspaceSendMessage = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceSendMessageBody: ThreadServiceSendMessageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendMessageResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/input`,
    threadServiceSendMessageBody,
    options,
  );
};

export const getWorkspaceSendMessageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSendMessage>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSendMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSendMessage>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceSendMessage(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSendMessage>>
>;
export type WorkspaceSendMessageMutationBody = ThreadServiceSendMessageBody;
export type WorkspaceSendMessageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sends a message to a thread (fire and forget).
 */
export const useWorkspaceSendMessage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSendMessage>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendMessageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSendMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns memory blocks with content resolved for the thread context:
- Agent-scoped blocks return base content
- Thread-scoped blocks return the thread's customization (or base if no override)

The runtime-content routes live under `/memory`; block config
templates (kind / scope / etc.) live under `/memory-blocks`
managed by `MemoryService`.
 * @summary ============================================================================
Thread Memory
============================================================================
Gets all memory blocks with resolved content for a thread.
 */
export const workspaceGetThreadMemory = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadMemoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetThreadMemoryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadMemoryQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetThreadMemoryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadMemoryQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadMemoryQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThreadMemory>>
  > = ({ signal }) =>
    workspaceGetThreadMemory(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadMemoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThreadMemory>>
>;
export type WorkspaceGetThreadMemoryQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThreadMemory<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetThreadMemoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadMemory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadMemory<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadMemory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadMemory<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Thread Memory
============================================================================
Gets all memory blocks with resolved content for a thread.
 */

export function useWorkspaceGetThreadMemory<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadMemoryQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a specific memory block with resolved content for a thread.
 */
export const workspaceGetThreadMemoryBlock = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetThreadMemoryBlockParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetThreadMemoryBlockQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  blockId?: string,
  params?: WorkspaceGetThreadMemoryBlockParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetThreadMemoryBlockQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetThreadMemoryBlockQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>
  > = ({ signal }) =>
    workspaceGetThreadMemoryBlock(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId && blockId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetThreadMemoryBlockQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>
>;
export type WorkspaceGetThreadMemoryBlockQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params: undefined | WorkspaceGetThreadMemoryBlockParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a specific memory block with resolved content for a thread.
 */

export function useWorkspaceGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetThreadMemoryBlockQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    blockId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Only thread-scoped blocks can be cleared through this endpoint.
This removes the thread's customization, revealing the base content.
Agent-scoped blocks must be cleared through the MemoryService.
Returns FAILED_PRECONDITION if the block is agent-scoped.
 * @summary Clears memory block content in a thread context.
 */
export const workspaceClearThreadMemory = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceClearThreadMemoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceClearThreadMemory200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceClearThreadMemoryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceClearThreadMemory>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: WorkspaceClearThreadMemoryParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceClearThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: WorkspaceClearThreadMemoryParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceClearThreadMemory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceClearThreadMemory>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: WorkspaceClearThreadMemoryParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, blockId, params } =
      props ?? {};

    return workspaceClearThreadMemory(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceClearThreadMemoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceClearThreadMemory>>
>;

export type WorkspaceClearThreadMemoryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Clears memory block content in a thread context.
 */
export const useWorkspaceClearThreadMemory = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceClearThreadMemory>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        blockId: string;
        params?: WorkspaceClearThreadMemoryParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceClearThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: WorkspaceClearThreadMemoryParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceClearThreadMemoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Only thread-scoped blocks can be updated through this endpoint.
Agent-scoped blocks must be updated through the MemoryService.
Returns FAILED_PRECONDITION if the block is agent-scoped.
 * @summary Updates memory block content in a thread context.
 */
export const workspaceUpdateThreadMemory = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  threadServiceUpdateThreadMemoryBody: ThreadServiceUpdateThreadMemoryBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    threadServiceUpdateThreadMemoryBody,
    options,
  );
};

export const getWorkspaceUpdateThreadMemoryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateThreadMemory>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: ThreadServiceUpdateThreadMemoryBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: ThreadServiceUpdateThreadMemoryBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateThreadMemory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateThreadMemory>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: ThreadServiceUpdateThreadMemoryBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, blockId, data } =
      props ?? {};

    return workspaceUpdateThreadMemory(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateThreadMemoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateThreadMemory>>
>;
export type WorkspaceUpdateThreadMemoryMutationBody =
  ThreadServiceUpdateThreadMemoryBody;
export type WorkspaceUpdateThreadMemoryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates memory block content in a thread context.
 */
export const useWorkspaceUpdateThreadMemory = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateThreadMemory>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        blockId: string;
        data: ThreadServiceUpdateThreadMemoryBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: ThreadServiceUpdateThreadMemoryBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceUpdateThreadMemoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if no active plan exists.
 * @summary Gets the active plan snapshot for a thread (with per-step
statuses). Distinct from `GET /plan`, which returns the template.
 */
export const workspaceGetActivePlan = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetActivePlanParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/plan/active`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetActivePlanQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetActivePlanParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/plan/active`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetActivePlanQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetActivePlanQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetActivePlan>>
  > = ({ signal }) =>
    workspaceGetActivePlan(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetActivePlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetActivePlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetActivePlan>>
>;
export type WorkspaceGetActivePlanQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetActivePlan<
  TData = Awaited<ReturnType<typeof workspaceGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetActivePlanParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetActivePlan>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetActivePlan>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetActivePlan>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetActivePlan<
  TData = Awaited<ReturnType<typeof workspaceGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetActivePlan>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetActivePlan>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetActivePlan>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetActivePlan<
  TData = Awaited<ReturnType<typeof workspaceGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the active plan snapshot for a thread (with per-step
statuses). Distinct from `GET /plan`, which returns the template.
 */

export function useWorkspaceGetActivePlan<
  TData = Awaited<ReturnType<typeof workspaceGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetActivePlanQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns NOT_FOUND if no active plan exists or the phase/step index
is invalid.
Returns FAILED_PRECONDITION if the thread is currently generating,
the step is not in the active phase, or the step is already
resolved.
 * @summary Marks a step on the active plan as completed or failed.
 */
export const workspaceMarkStep = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  phaseIndex: number,
  stepIndex: number,
  threadServiceMarkStepBody: ThreadServiceMarkStepBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/plan/active/phases/${phaseIndex}/steps/${stepIndex}:mark`,
    threadServiceMarkStepBody,
    options,
  );
};

export const getWorkspaceMarkStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceMarkStep>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      phaseIndex: number;
      stepIndex: number;
      data: ThreadServiceMarkStepBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceMarkStep>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    phaseIndex: number;
    stepIndex: number;
    data: ThreadServiceMarkStepBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceMarkStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceMarkStep>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      phaseIndex: number;
      stepIndex: number;
      data: ThreadServiceMarkStepBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      agentId,
      threadId,
      phaseIndex,
      stepIndex,
      data,
    } = props ?? {};

    return workspaceMarkStep(
      organization,
      workspace,
      agentId,
      threadId,
      phaseIndex,
      stepIndex,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceMarkStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceMarkStep>>
>;
export type WorkspaceMarkStepMutationBody = ThreadServiceMarkStepBody;
export type WorkspaceMarkStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Marks a step on the active plan as completed or failed.
 */
export const useWorkspaceMarkStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceMarkStep>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        phaseIndex: number;
        stepIndex: number;
        data: ThreadServiceMarkStepBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceMarkStep>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    phaseIndex: number;
    stepIndex: number;
    data: ThreadServiceMarkStepBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceMarkStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * No generation guard — always allowed.
Returns NOT_FOUND if no active plan exists.
Returns FAILED_PRECONDITION if the plan is not active.
 * @summary Deactivates the active plan. The snapshot is kept (flagged
inactive) for status carry-over on the next activation.
 */
export const workspaceDeactivatePlan = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceDeactivatePlanBody: ThreadServiceDeactivatePlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/plan/active:deactivate`,
    threadServiceDeactivatePlanBody,
    options,
  );
};

export const getWorkspaceDeactivatePlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeactivatePlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeactivatePlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeactivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeactivatePlanBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeactivatePlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeactivatePlan>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeactivatePlanBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceDeactivatePlan(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeactivatePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeactivatePlan>>
>;
export type WorkspaceDeactivatePlanMutationBody =
  ThreadServiceDeactivatePlanBody;
export type WorkspaceDeactivatePlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deactivates the active plan. The snapshot is kept (flagged
inactive) for status carry-over on the next activation.
 */
export const useWorkspaceDeactivatePlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeactivatePlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeactivatePlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeactivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeactivatePlanBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeactivatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears all step statuses and failure reasons. If the plan is
active, it is deactivated first before resetting.
Returns NOT_FOUND if no active plan exists.
Returns FAILED_PRECONDITION if the thread is currently generating.
 * @summary Resets all step statuses on the active plan back to pending.
 */
export const workspaceResetPlan = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceResetPlanBody: ThreadServiceResetPlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/plan/active:reset`,
    threadServiceResetPlanBody,
    options,
  );
};

export const getWorkspaceResetPlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceResetPlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetPlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceResetPlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetPlanBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceResetPlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceResetPlan>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetPlanBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceResetPlan(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceResetPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceResetPlan>>
>;
export type WorkspaceResetPlanMutationBody = ThreadServiceResetPlanBody;
export type WorkspaceResetPlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resets all step statuses on the active plan back to pending.
 */
export const useWorkspaceResetPlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceResetPlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetPlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceResetPlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetPlanBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceResetPlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if no plan template exists.
Returns FAILED_PRECONDITION if the thread is currently generating,
the plan is already active, or the template has no phases.
 * @summary Activates the plan for a thread. Snapshots the current template
plan and carries over statuses from any previous snapshot by id.
 */
export const workspaceActivatePlan = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceActivatePlanBody: ThreadServiceActivatePlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/plan:activate`,
    threadServiceActivatePlanBody,
    options,
  );
};

export const getWorkspaceActivatePlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceActivatePlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceActivatePlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceActivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceActivatePlanBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceActivatePlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceActivatePlan>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceActivatePlanBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceActivatePlan(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceActivatePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceActivatePlan>>
>;
export type WorkspaceActivatePlanMutationBody = ThreadServiceActivatePlanBody;
export type WorkspaceActivatePlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Activates the plan for a thread. Snapshots the current template
plan and carries over statuses from any previous snapshot by id.
 */
export const useWorkspaceActivatePlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceActivatePlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceActivatePlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceActivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceActivatePlanBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceActivatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Read-only and observational. The queue is the to-do list of not-yet-started
work; the in-flight suspension itself lives in the event-log tail (see
GetEvents), not here. Groups are returned in drain order (head first).
 * @summary Retrieves the thread's durable queue: the deferred suspend-type work
(remote tool calls, an interrupt, a sleep, a transfer, sub-agent
task/resume) and any parked user input not yet enacted.
 */
export const workspaceGetQueue = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetQueueParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetQueueResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/queue`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetQueueQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetQueueParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/queue`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetQueueQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetQueue>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetQueueQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetQueue>>
  > = ({ signal }) =>
    workspaceGetQueue(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetQueue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetQueueQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetQueue>>
>;
export type WorkspaceGetQueueQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetQueue<
  TData = Awaited<ReturnType<typeof workspaceGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetQueueParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetQueue>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetQueue>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetQueue>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetQueue<
  TData = Awaited<ReturnType<typeof workspaceGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetQueue>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetQueue>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetQueue>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetQueue<
  TData = Awaited<ReturnType<typeof workspaceGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetQueue>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves the thread's durable queue: the deferred suspend-type work
(remote tool calls, an interrupt, a sleep, a transfer, sub-agent
task/resume) and any parked user input not yet enacted.
 */

export function useWorkspaceGetQueue<
  TData = Awaited<ReturnType<typeof workspaceGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetQueue>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetQueueQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Appends a synthetic ToolCallStart (plus one ToolCallArgument per supplied
argument) to the thread event log under the generation lock, executes the
tool through the normal dispatcher, and continues with an LLM turn that
has the tool result in context. Equivalent in effect to the LLM having
chosen to call this tool itself.
 * @summary Injects a deterministic tool call into a thread.
 */
export const workspaceSendToolCall = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceSendToolCallBody: ThreadServiceSendToolCallBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendToolCallResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-calls`,
    threadServiceSendToolCallBody,
    options,
  );
};

export const getWorkspaceSendToolCallMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSendToolCall>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolCallBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSendToolCall>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolCallBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSendToolCall'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSendToolCall>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolCallBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceSendToolCall(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSendToolCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSendToolCall>>
>;
export type WorkspaceSendToolCallMutationBody = ThreadServiceSendToolCallBody;
export type WorkspaceSendToolCallMutationError = AxiosError<RpcStatus>;

/**
 * @summary Injects a deterministic tool call into a thread.
 */
export const useWorkspaceSendToolCall = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSendToolCall>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendToolCallBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSendToolCall>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolCallBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSendToolCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remote tools pause generation when called, waiting for an external system
to execute them and return the result via this RPC. Generation resumes
once the result is received.
 * @summary Sends a tool execution result for a remote tool.
 */
export const workspaceSendToolResult = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceSendToolResultBody: ThreadServiceSendToolResultBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendToolResultResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tool-results`,
    threadServiceSendToolResultBody,
    options,
  );
};

export const getWorkspaceSendToolResultMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSendToolResult>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolResultBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSendToolResult>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolResultBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSendToolResult'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSendToolResult>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolResultBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceSendToolResult(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSendToolResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSendToolResult>>
>;
export type WorkspaceSendToolResultMutationBody =
  ThreadServiceSendToolResultBody;
export type WorkspaceSendToolResultMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sends a tool execution result for a remote tool.
 */
export const useWorkspaceSendToolResult = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSendToolResult>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendToolResultBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSendToolResult>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolResultBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSendToolResultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns tool details resolved with thread variables.
 * @summary Gets a single tool by its stable tool_id for a specific thread.
 */
export const workspaceGetTool = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: WorkspaceGetToolParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Tool>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${toolId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetToolQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  toolId?: string,
  params?: WorkspaceGetToolParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools/${toolId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetToolQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: WorkspaceGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetTool>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetToolQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      toolId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetTool>>
  > = ({ signal }) =>
    workspaceGetTool(
      organization,
      workspace,
      agentId,
      threadId,
      toolId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId && toolId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetTool>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetToolQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetTool>>
>;
export type WorkspaceGetToolQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetTool<
  TData = Awaited<ReturnType<typeof workspaceGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params: undefined | WorkspaceGetToolParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetTool>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetTool>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetTool>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetTool<
  TData = Awaited<ReturnType<typeof workspaceGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: WorkspaceGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetTool>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetTool>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetTool>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetTool<
  TData = Awaited<ReturnType<typeof workspaceGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: WorkspaceGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetTool>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a single tool by its stable tool_id for a specific thread.
 */

export function useWorkspaceGetTool<
  TData = Awaited<ReturnType<typeof workspaceGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: WorkspaceGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetTool>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetToolQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    toolId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The tool executes in the context of a thread (for artifact, memory, and
plan access) but nothing is appended to thread history. Useful for testing,
automation, and external integrations.
 * @summary Invokes a tool directly without LLM involvement.
 */
export const workspaceInvokeTool = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceInvokeToolBody: ThreadServiceInvokeToolBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InvokeToolResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/tools:invoke`,
    threadServiceInvokeToolBody,
    options,
  );
};

export const getWorkspaceInvokeToolMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceInvokeTool>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceInvokeToolBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceInvokeTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceInvokeToolBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceInvokeTool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceInvokeTool>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceInvokeToolBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceInvokeTool(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceInvokeToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceInvokeTool>>
>;
export type WorkspaceInvokeToolMutationBody = ThreadServiceInvokeToolBody;
export type WorkspaceInvokeToolMutationError = AxiosError<RpcStatus>;

/**
 * @summary Invokes a tool directly without LLM involvement.
 */
export const useWorkspaceInvokeTool = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceInvokeTool>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceInvokeToolBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceInvokeTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceInvokeToolBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceInvokeToolMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * When the agent has no utility generator configured this falls back
to the main generator, so the returned info always describes the
model that will actually run utility tasks.
 * @summary Gets model information and capabilities for the agent's utility
generator (the secondary generator used for thread titling and
other lightweight LLM calls around the conversation).
 */
export const workspaceGetUtilityGeneratorModelInfo = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetUtilityGeneratorModelInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ModelInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/utility-generator:model-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetUtilityGeneratorModelInfoQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetUtilityGeneratorModelInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/utility-generator:model-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetUtilityGeneratorModelInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetUtilityGeneratorModelInfoQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>
  > = ({ signal }) =>
    workspaceGetUtilityGeneratorModelInfo(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetUtilityGeneratorModelInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>
>;
export type WorkspaceGetUtilityGeneratorModelInfoQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetUtilityGeneratorModelInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets model information and capabilities for the agent's utility
generator (the secondary generator used for thread titling and
other lightweight LLM calls around the conversation).
 */

export function useWorkspaceGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetUtilityGeneratorModelInfoQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Compaction summarizes conversation history to reduce context size while
preserving essential information. This RPC emits a CompactStart event
and returns the compact_id for tracking.

The actual compaction is performed asynchronously. Once complete, a
CompactComplete event with the summary content should be added to the
thread using the returned compact_id.

While compaction is in progress (CompactStart without CompactComplete),
the UI should block user input.
 * @summary Starts context compaction for a thread.
 */
export const workspaceStartCompaction = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceStartCompactionBody: ThreadServiceStartCompactionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StartCompactionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:compact`,
    threadServiceStartCompactionBody,
    options,
  );
};

export const getWorkspaceStartCompactionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceStartCompaction>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStartCompactionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceStartCompaction>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStartCompactionBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceStartCompaction'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceStartCompaction>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStartCompactionBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceStartCompaction(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceStartCompactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceStartCompaction>>
>;
export type WorkspaceStartCompactionMutationBody =
  ThreadServiceStartCompactionBody;
export type WorkspaceStartCompactionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Starts context compaction for a thread.
 */
export const useWorkspaceStartCompaction = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceStartCompaction>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceStartCompactionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceStartCompaction>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStartCompactionBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceStartCompactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Dehydrates an idle thread: archives all of its data to the configured
dehydrated thread store and leaves a tombstone that still lists but cannot
generate. Returns FAILED_PRECONDITION when dehydration is not configured or
the thread is ineligible (not quiescent, queue non-empty, or sleeping).
 */
export const workspaceDehydrateThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceDehydrateThreadBody: ThreadServiceDehydrateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:dehydrate`,
    threadServiceDehydrateThreadBody,
    options,
  );
};

export const getWorkspaceDehydrateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDehydrateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDehydrateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDehydrateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceDehydrateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDehydrateThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDehydrateThreadBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceDehydrateThread(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDehydrateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDehydrateThread>>
>;
export type WorkspaceDehydrateThreadMutationBody =
  ThreadServiceDehydrateThreadBody;
export type WorkspaceDehydrateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Dehydrates an idle thread: archives all of its data to the configured
dehydrated thread store and leaves a tombstone that still lists but cannot
generate. Returns FAILED_PRECONDITION when dehydration is not configured or
the thread is ineligible (not quiescent, queue non-empty, or sleeping).
 */
export const useWorkspaceDehydrateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDehydrateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDehydrateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDehydrateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDehydrateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new thread that is a complete copy of the source thread,
including events, feedback, memory customizations, scratchpad, plan,
and template config customizations.
Returns FAILED_PRECONDITION if the source thread is currently generating.
 * @summary Forks (duplicates) a thread with all its data.
 */
export const workspaceForkThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceForkThreadBody: ThreadServiceForkThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:fork`,
    threadServiceForkThreadBody,
    options,
  );
};

export const getWorkspaceForkThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceForkThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceForkThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceForkThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceForkThreadBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceForkThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceForkThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceForkThreadBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceForkThread(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceForkThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceForkThread>>
>;
export type WorkspaceForkThreadMutationBody = ThreadServiceForkThreadBody;
export type WorkspaceForkThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Forks (duplicates) a thread with all its data.
 */
export const useWorkspaceForkThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceForkThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceForkThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceForkThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceForkThreadBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceForkThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Rehydrates a dehydrated thread: restores its data from the archive and
returns it to normal operation. Returns FAILED_PRECONDITION when the thread
is not dehydrated.
 */
export const workspaceRehydrateThread = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceRehydrateThreadBody: ThreadServiceRehydrateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:rehydrate`,
    threadServiceRehydrateThreadBody,
    options,
  );
};

export const getWorkspaceRehydrateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceRehydrateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRehydrateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceRehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRehydrateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceRehydrateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceRehydrateThread>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRehydrateThreadBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceRehydrateThread(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceRehydrateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceRehydrateThread>>
>;
export type WorkspaceRehydrateThreadMutationBody =
  ThreadServiceRehydrateThreadBody;
export type WorkspaceRehydrateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Rehydrates a dehydrated thread: restores its data from the archive and
returns it to normal operation. Returns FAILED_PRECONDITION when the thread
is not dehydrated.
 */
export const useWorkspaceRehydrateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceRehydrateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceRehydrateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceRehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRehydrateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceRehydrateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * If a generation is currently running, it will be cancelled and a
GenerationFailed event with STOPPED kind will be emitted. If no
generation is in progress, this is a no-op and returns stopped=false.
 * @summary Stops an in-progress generation in a thread.
 */
export const workspaceStop = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceStopBody: ThreadServiceStopBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StopResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:stop`,
    threadServiceStopBody,
    options,
  );
};

export const getWorkspaceStopMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceStop>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStopBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceStop>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStopBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceStop'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceStop>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStopBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceStop(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceStopMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceStop>>
>;
export type WorkspaceStopMutationBody = ThreadServiceStopBody;
export type WorkspaceStopMutationError = AxiosError<RpcStatus>;

/**
 * @summary Stops an in-progress generation in a thread.
 */
export const useWorkspaceStop = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceStop>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceStopBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceStop>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStopBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceStopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Operator-forced transfer: hand the live conversation to another profile on
the same thread (a profile swap), bypassing the agent allowlist. Triggers a
generation as the new profile; observe it via the event stream.
 */
export const workspaceTransfer = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceTransferBody: ThreadServiceTransferBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceTransfer200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:transfer`,
    threadServiceTransferBody,
    options,
  );
};

export const getWorkspaceTransferMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceTransfer>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceTransferBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceTransfer>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceTransferBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceTransfer'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceTransfer>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceTransferBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceTransfer(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceTransfer>>
>;
export type WorkspaceTransferMutationBody = ThreadServiceTransferBody;
export type WorkspaceTransferMutationError = AxiosError<RpcStatus>;

/**
 * @summary Operator-forced transfer: hand the live conversation to another profile on
the same thread (a profile swap), bypassing the agent allowlist. Triggers a
generation as the new profile; observe it via the event stream.
 */
export const useWorkspaceTransfer = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceTransfer>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceTransferBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceTransfer>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceTransferBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceTransferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Atomically ends the pending sleep with `interrupted_by_user = true`,
cancels the scheduled wake task, and triggers a new generation so the
LLM observes the early return in its rebuilt history. No-op when no
sleep is pending; the call still triggers a normal Reminder-driven
resume in that case.
 * @summary Wakes a thread that is currently sleeping (UI "Wake up" button).
 */
export const workspaceWake = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  threadServiceWakeBody: ThreadServiceWakeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1WakeResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}:wake`,
    threadServiceWakeBody,
    options,
  );
};

export const getWorkspaceWakeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceWake>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceWakeBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceWake>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceWakeBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceWake'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceWake>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceWakeBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceWake(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceWakeMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceWake>>
>;
export type WorkspaceWakeMutationBody = ThreadServiceWakeBody;
export type WorkspaceWakeMutationError = AxiosError<RpcStatus>;

/**
 * @summary Wakes a thread that is currently sleeping (UI "Wake up" button).
 */
export const useWorkspaceWake = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceWake>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceWakeBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceWake>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceWakeBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceWakeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The bulk counterpart of UpgradeThread, for re-pinning an agent's whole
fleet after a backward-incompatible version change without iterating
thread-by-thread. Threads may be narrowed by an REL `filter` (empty means
all) and are scoped to the request's parent. Each thread is upgraded
independently: one that is already current, is missing required
variables, or fails to write is reported individually and does not abort
the rest. The response carries a per-thread result and rollup counts.
 * @summary Move every thread of an agent to a target agent version in one call.
 */
export const workspaceUpgradeAllThreads = (
  organization: string,
  workspace: string,
  agentId: string,
  threadServiceUpgradeAllThreadsBody: ThreadServiceUpgradeAllThreadsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeAllThreadsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads:upgradeAll`,
    threadServiceUpgradeAllThreadsBody,
    options,
  );
};

export const getWorkspaceUpgradeAllThreadsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpgradeAllThreads>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ThreadServiceUpgradeAllThreadsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpgradeAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ThreadServiceUpgradeAllThreadsBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpgradeAllThreads'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpgradeAllThreads>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ThreadServiceUpgradeAllThreadsBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceUpgradeAllThreads(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpgradeAllThreadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpgradeAllThreads>>
>;
export type WorkspaceUpgradeAllThreadsMutationBody =
  ThreadServiceUpgradeAllThreadsBody;
export type WorkspaceUpgradeAllThreadsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move every thread of an agent to a target agent version in one call.
 */
export const useWorkspaceUpgradeAllThreads = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpgradeAllThreads>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ThreadServiceUpgradeAllThreadsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpgradeAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ThreadServiceUpgradeAllThreadsBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpgradeAllThreadsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Tools are resolved with thread variables, so tool availability may vary
between threads depending on variable configuration. Use this endpoint
to get the actual tools available in a thread context.

Also mirrored on `ToolCatalogService::ListTools` (same shape; the
catalog service exposes `:diff` next to it). New callers should
prefer the `ToolCatalogService` variant; this one is kept for
backwards-compatible gRPC clients.
 * @summary ============================================================================
Tool Discovery (Thread-Scoped)
============================================================================
Lists tools available to an agent for a specific thread.
 */
export const workspaceListTools = (
  organization: string,
  workspace: string,
  v1ListToolsRequest: V1ListToolsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/rain.v1.ThreadService/ListTools`,
    v1ListToolsRequest,
    options,
  );
};

export const getWorkspaceListToolsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceListTools>>,
    TError,
    { organization: string; workspace: string; data: V1ListToolsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceListTools>>,
  TError,
  { organization: string; workspace: string; data: V1ListToolsRequest },
  TContext
> => {
  const mutationKey = ['workspaceListTools'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceListTools>>,
    { organization: string; workspace: string; data: V1ListToolsRequest }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceListTools(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceListToolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListTools>>
>;
export type WorkspaceListToolsMutationBody = V1ListToolsRequest;
export type WorkspaceListToolsMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Tool Discovery (Thread-Scoped)
============================================================================
Lists tools available to an agent for a specific thread.
 */
export const useWorkspaceListTools = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceListTools>>,
      TError,
      { organization: string; workspace: string; data: V1ListToolsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceListTools>>,
  TError,
  { organization: string; workspace: string; data: V1ListToolsRequest },
  TContext
> => {
  const mutationOptions = getWorkspaceListToolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Streams live status transitions for every thread of one agent.
 */
export const workspaceSubscribeAgentThreadStatus = (
  organization: string,
  workspace: string,
  v1SubscribeAgentThreadStatusRequest: V1SubscribeAgentThreadStatusRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceSubscribeAgentThreadStatus200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/rain.v1.ThreadService/SubscribeAgentThreadStatus`,
    v1SubscribeAgentThreadStatusRequest,
    options,
  );
};

export const getWorkspaceSubscribeAgentThreadStatusMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSubscribeAgentThreadStatus>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: V1SubscribeAgentThreadStatusRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSubscribeAgentThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1SubscribeAgentThreadStatusRequest;
  },
  TContext
> => {
  const mutationKey = ['workspaceSubscribeAgentThreadStatus'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSubscribeAgentThreadStatus>>,
    {
      organization: string;
      workspace: string;
      data: V1SubscribeAgentThreadStatusRequest;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceSubscribeAgentThreadStatus(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSubscribeAgentThreadStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSubscribeAgentThreadStatus>>
>;
export type WorkspaceSubscribeAgentThreadStatusMutationBody =
  V1SubscribeAgentThreadStatusRequest;
export type WorkspaceSubscribeAgentThreadStatusMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Streams live status transitions for every thread of one agent.
 */
export const useWorkspaceSubscribeAgentThreadStatus = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSubscribeAgentThreadStatus>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: V1SubscribeAgentThreadStatusRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSubscribeAgentThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1SubscribeAgentThreadStatusRequest;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceSubscribeAgentThreadStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns a stream of events for the thread. If include_history is true,
existing events are sent first, followed by new events as they occur.
The stream stays open until the client disconnects.

This is the gRPC streaming alternative to SSE for internal clients.
 * @summary ============================================================================
Streaming Subscription
============================================================================
Subscribes to a thread's event stream.
 */
export const workspaceSubscribeThread = (
  organization: string,
  workspace: string,
  v1SubscribeThreadRequest: V1SubscribeThreadRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceSubscribeThread200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/rain.v1.ThreadService/SubscribeThread`,
    v1SubscribeThreadRequest,
    options,
  );
};

export const getWorkspaceSubscribeThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSubscribeThread>>,
    TError,
    { organization: string; workspace: string; data: V1SubscribeThreadRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSubscribeThread>>,
  TError,
  { organization: string; workspace: string; data: V1SubscribeThreadRequest },
  TContext
> => {
  const mutationKey = ['workspaceSubscribeThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSubscribeThread>>,
    { organization: string; workspace: string; data: V1SubscribeThreadRequest }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceSubscribeThread(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSubscribeThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSubscribeThread>>
>;
export type WorkspaceSubscribeThreadMutationBody = V1SubscribeThreadRequest;
export type WorkspaceSubscribeThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Streaming Subscription
============================================================================
Subscribes to a thread's event stream.
 */
export const useWorkspaceSubscribeThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSubscribeThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: V1SubscribeThreadRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSubscribeThread>>,
  TError,
  { organization: string; workspace: string; data: V1SubscribeThreadRequest },
  TContext
> => {
  const mutationOptions = getWorkspaceSubscribeThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Streams live status transitions for every thread within the caller's
parent scope (the cross-agent Threads console).
 */
export const workspaceSubscribeThreadStatus = (
  organization: string,
  workspace: string,
  v1SubscribeThreadStatusRequest: V1SubscribeThreadStatusRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceSubscribeThreadStatus200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/rain.v1.ThreadService/SubscribeThreadStatus`,
    v1SubscribeThreadStatusRequest,
    options,
  );
};

export const getWorkspaceSubscribeThreadStatusMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSubscribeThreadStatus>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: V1SubscribeThreadStatusRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSubscribeThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1SubscribeThreadStatusRequest;
  },
  TContext
> => {
  const mutationKey = ['workspaceSubscribeThreadStatus'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSubscribeThreadStatus>>,
    {
      organization: string;
      workspace: string;
      data: V1SubscribeThreadStatusRequest;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceSubscribeThreadStatus(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSubscribeThreadStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSubscribeThreadStatus>>
>;
export type WorkspaceSubscribeThreadStatusMutationBody =
  V1SubscribeThreadStatusRequest;
export type WorkspaceSubscribeThreadStatusMutationError = AxiosError<RpcStatus>;

/**
 * @summary Streams live status transitions for every thread within the caller's
parent scope (the cross-agent Threads console).
 */
export const useWorkspaceSubscribeThreadStatus = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSubscribeThreadStatus>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: V1SubscribeThreadStatusRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSubscribeThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1SubscribeThreadStatusRequest;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceSubscribeThreadStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists threads across every agent visible to the caller's parent scope
(the cross-agent Threads console) — server-paged and searched, each
thread carrying its materialized status and its owning agent's name.
 */
export const workspaceListAllThreads = (
  organization: string,
  workspace: string,
  params?: WorkspaceListAllThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAllThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListAllThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceListAllThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListAllThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListAllThreadsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListAllThreads>>
  > = ({ signal }) =>
    workspaceListAllThreads(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListAllThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListAllThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListAllThreads>>
>;
export type WorkspaceListAllThreadsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListAllThreads<
  TData = Awaited<ReturnType<typeof workspaceListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | WorkspaceListAllThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAllThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAllThreads>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAllThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAllThreads<
  TData = Awaited<ReturnType<typeof workspaceListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAllThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListAllThreads>>,
          TError,
          Awaited<ReturnType<typeof workspaceListAllThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListAllThreads<
  TData = Awaited<ReturnType<typeof workspaceListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists threads across every agent visible to the caller's parent scope
(the cross-agent Threads console) — server-paged and searched, each
thread carrying its materialized status and its owning agent's name.
 */

export function useWorkspaceListAllThreads<
  TData = Awaited<ReturnType<typeof workspaceListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListAllThreadsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The thread console's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts (agent and
origin ids carry display names). `query` scopes the counts; the active
filter is not an input.
 */
export const workspaceGetFilterSchema = (
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1FilterSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/threads:filter-schema`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetFilterSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  params?: WorkspaceGetFilterSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/threads:filter-schema`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetFilterSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetFilterSchemaQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetFilterSchema>>
  > = ({ signal }) =>
    workspaceGetFilterSchema(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetFilterSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetFilterSchema>>
>;
export type WorkspaceGetFilterSchemaQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | WorkspaceGetFilterSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary The thread console's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts (agent and
origin ids carry display names). `query` scopes the counts; the active
filter is not an input.
 */

export function useWorkspaceGetFilterSchema<
  TData = Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: WorkspaceGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetFilterSchemaQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
